<template>
    <div>
        <div v-if="$loadingRouteData"
             class="container -producer">
            <loader></loader>
        </div>

        <div v-if="!$loadingRouteData"
             class="container -sheet-companies">
            <ol class="breadcrumb">
                <li><a v-link="{name: 'home'}">Accueil</a></li>
                <li>Borderaux</li>
            </ol>

            <div class="heading">
                <h1>Choisir une compagnie</h1>
            </div>

            <div class="row"
                 v-for="chunk of companies | makeChunks 4">
                <div class="col-sm-3"
                     v-for="c of chunk">
                    <a v-link="{name: 'sheet-add', params: {company: c.id}}"
                       class="btn btn-link btn-lg -company">
                        {{ c.name }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/css" scoped>
    .btn {
        text-align: center;
        width: 100%;
    }
</style>

<script type="text/ecmascript-6">
    import Loader from '../components/Loader';
    import {getAllCompanies} from '../api/companies';
    import router from '../router';

    export default {
        components: {
            Loader
        },
        data() {
            return {
                companies: []
            };
        },
        route: {
            data: async function () {
                try {
                    return {
                        companies: await getAllCompanies()
                    };
                } catch (e) {
                    router.replace({name: 'not-found'});
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// SheetCompanies.vue?4e93e2e2